import * as immutable from 'object-path-immutable';
import * as types from './actionTypes';

const initialState = {
  list: {},
};

export default function modalReducer(state = initialState, action) {
  switch (action.type) {
    case types.SHOW_MODAL: {
      return immutable.assign(state, ['list', action.payload.name], {
        params: action.payload.params,
        isOpen: true,
      });
    }

    case types.HIDE_MODAL: {
      return immutable.assign(state, ['list', action.payload.name], {
        params: {},
        isOpen: false,
      });
    }

    default:
      return state;
  }
}
